import { useState, useEffect, useRef } from "react";
import { useMediaQuery } from "react-responsive";

function Slider({
  images = [], // Desktop images
  mobileImages = [], // Mobile images
  laptopImages = [], // Laptop images
  effects = [],
  interval = 3000,  
}) {
  const [currentEffectIndex, setCurrentEffectIndex] = useState(0);
  const [currentSlide, setCurrentSlide] = useState(0);
  const intervalRef = useRef(null);

  // Detect screen sizes
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const isLaptop = useMediaQuery({ minWidth: 768, maxWidth: 1440 });

  // Choose images based on screen size
  const imagesToDisplay = isMobile
    ? mobileImages
    : isLaptop
    ? laptopImages
    : images; // Default to desktop images if not mobile or laptop

  // Function to change effect and go to the next slide
  const nextSlide = () => {
    setCurrentSlide((prevSlide) => (prevSlide + 1) % imagesToDisplay.length);
    setCurrentEffectIndex((prevIndex) => (prevIndex + 1) % effects.length);
    resetAutoSlide();
  };

  // Function to change effect and go to the previous slide
  const prevSlide = () => {
    setCurrentSlide(
      (prevSlide) =>
        (prevSlide - 1 + imagesToDisplay.length) % imagesToDisplay.length
    );
    setCurrentEffectIndex(
      (prevIndex) => (prevIndex - 1 + effects.length) % effects.length
    );
    resetAutoSlide();
  };

  // Function to start auto-slide
  const startAutoSlide = () => {
    intervalRef.current = setInterval(() => {
      nextSlide();
    }, interval);
  };

  // Function to reset auto-slide timer
  const resetAutoSlide = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
    startAutoSlide();
  };

  // Auto Slide Change on mount
  useEffect(() => {
    startAutoSlide();
    return () => clearInterval(intervalRef.current); // Cleanup on unmount
  }, []);

  // Ensure imagesToDisplay is an array and has at least one item before rendering
  if (!imagesToDisplay || imagesToDisplay.length === 0) {
    console.log("Images array:", images);
    console.log("Mobile Images array:", mobileImages);
    console.log("Laptop Images array:", laptopImages);

    return <div>No images available</div>; // Optionally handle this gracefully
  }

  return (
    <div className="slider-container">
      <div className={`slider ${effects[currentEffectIndex]}`}>
        {imagesToDisplay.map((image, index) => (
          <div
            key={index}
            className={`slide ${index === currentSlide ? "active" : ""}`}
          >
            <img src={image} alt={`Slide ${index}`} />
          </div>
        ))}
      </div>

      {/* Navigation Buttons */}
      <button className="prev button" onClick={prevSlide}>
        ❮
      </button>
      <button className="next button" onClick={nextSlide}>
        ❯
      </button>
    </div>
  );
}

export default Slider;
